@import 'common/stylesheets/mixins/common'

info-color = var(--blue1)
success-color = var(--green1)
error-color = var(--red1)
warn-color = var(--orange1)

banner-theme-styles(svg-icon-color, bg-color, border-color)
  svg-icon.banner-title-icon
    color svg-icon-color

  &.embedded-type
    background-color bg-color
    border 1px solid border-color

+host-styles('.banner-wrapper')
  display block

.banner-wrapper
  mp-drop-box-shadow()
  background-color var(--background-color)
  border-radius $border-radius-panel
  
  .banner-title-icon
    svg-icon-style-props()

  .banner-icon-wrapper
    display flex
    justify-content space-between

  .banner-panel
    display flex
    padding 16px 16px 0 16px // hack in order to add extra margins between copy and actions and utilize flexbox

    &.marketing-theme
      align-items center
      border-radius 12px
      justify-content center
      padding 16px

    .banner-copy
      margin-bottom 16px
      min-width 0

      &.has-image,
      &.marketing-theme
        margin-bottom 0

    .banner-body
      color var(--secondary-text-color)

      &.info-blue-theme
        color var(--primary-text-color)

      &.marketing-theme
        color var(--primary-text-color)
        font-size $font-size-large
        font-weight $weight-regular

      /* stylelint-disable-next-line stylus-modules/no-broad-descendant-selectors */
      a
        color var(--secondary-text-color)
        text-decoration underline

    .banner-header
      color var(--primary-text-color)

    .banner-footer
      color var(--tertiary-text-color)
      margin-top 5px

    .banner-image
      border-radius 6px
      height 72px
      margin-right 16px
      width 108px

    .banner-content
      display flex
      flex-wrap wrap
      justify-content space-between
      line-height 20px
      width 100%

      &.nowrap
        flex-wrap nowrap

      &.gradient-blue-theme, &.gradient-red-theme, &.info-blue-theme
        flex-wrap nowrap
        gap 16px

    .banner-actions
      align-items center
      display flex
      margin-bottom 16px

      &.has-image,
      &.marketing-theme
        margin-bottom 0

      .cta-button
        margin-right 5px

    .banner-tooltip
      display inline
      padding-left 2px

    .banner-title-icon
      margin-right 8px

    &.base-theme, &.base-column-theme
      banner-theme-styles(var(--primary-text-color), var(--secondary-background-color), var(--component-outline-color))

    &.base-column-theme
      flex-direction column

      .banner-actions, .banner-content
        flex-direction column
      .banner-actions .cta-button
        width 100%

    &.info-theme
      banner-theme-styles(info-color, 'rgba(%s, 0.1)' % var(--blue1-rgb), info-color)

    &.success-theme
      banner-theme-styles(success-color, 'rgba(%s, 0.1)' % var(--green1-rgb), success-color)

    &.error-theme
      banner-theme-styles(error-color, 'rgba(%s, 0.1)' % var(--red1-rgb), error-color)

    &.warn-theme
      banner-theme-styles(warn-color, 'rgba(%s, 0.1)' % var(--orange1-rgb), warn-color)

    &.marketing-theme
      background-color 'rgba(%s, 0.1)' % var(--blue1-rgb)
      border 1px solid 'rgba(%s, 0.2)' % var(--blue1-rgb)

    &.gradient-blue-theme, &.gradient-red-theme
      border 1px solid var(--grey2)
      border-radius 12px

    &.gradient-red-theme
      background-image linear-gradient(to right, var(--gray0), rgba(255, 0, 0, 0.1))

    &.gradient-blue-theme
      background-image linear-gradient(to right, var(--gray0), rgba(0, 0, 255, 0.1))

    &.info-blue-theme
      background-color rgba(79, 68, 224, 0.1)
      border 1px solid rgb(79, 68, 224)
      border-radius 12px

    &.extra-small-size
      font-size $font-size-medium

    &.small-size
      padding 12px 13px

      &.has-cta
        padding 7px 2px 7px 13px

        /* stylelint-disable-next-line stylus-modules/no-broad-descendant-selectors */
        svg-icon
          margin-top 5px

      &.body-only
        slot.banner-body
          display block

      .banner-content
        line-height 18px

      .banner-copy
        align-items center
        display flex
        justify-content center
        margin-bottom 0

      .banner-actions
        margin-bottom 0

    &.medium-size
      .banner-header
        font-size $font-size-large
        font-weight $weight-bold
        margin-bottom 2px

        &.marketing-theme
          font-size $font-size-xl

  &.embedded-type
    box-shadow none

    .banner-panel
      border-radius 12px

  &.marketing-theme
    box-shadow none
